import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent, trackKey } from '@classic/Foundation/Analytics/GoogleTagManagerService'

export const trackSignUpClick = (location: 'header' | 'login-modal' | 'hamburger') =>
  trackEvent(keys.signUpClicked, {
    location,
  })

export const trackSignUpVerifyAddress = (addressMethod: 'auto' | 'manual') =>
  trackEvent(keys.signUpVerifyAddress, { addressMethod })

export const trackSignUpNeedAssistance = () => trackKey(keys.signUpNeedAssistance)

export const trackSignUpUnsuccessful = () => trackKey(keys.signUpUnsuccessful)

export const trackSignUpUnsuccessfulCallUs = () => trackKey(keys.signUpUnsuccessfulCallUs)
